<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import config from "../static/config.json";
import { isPc, isWeixin } from "./utils/tool.js";
export default {
  data() {
    return {};
  },
  mounted() {
    console.log("oidcIsAuthenticated", this.oidcIsAuthenticated);
    console.log("oidcIsAuthenticated", this.oidcIsAuthenticated);
    const that = this;
    window.addEventListener("vuexoidc:accessTokenExpiring", function() {
      that.authenticateOidcSilent;
    });
  },
  watch: {
    $route(to, form) {
      if (to.fullPath !== form.fullPath) {
        this.addLink("https://v1.cnzz.com/z_stat.php?id=1279371211&web_id=1279371211");
        this.addLink("https://v1.cnzz.com/z_stat.php?id=1279666456&web_id=1279666456");
      }
      // this.$service.refreshUrl(); // 强制刷新 去除微信二次分享的配置后的url
      if (!to.meta.isShare) {
        // 未分享页面
        // this.wxHideAllMenu(); // 隐藏微信分享菜单
        this.getConfig();
        const opt = {
          title: document.title,
          desc: window.location.href,
          link: window.location.href,
          imgUrl: this.exhibitionInfo ? this.exhibitionInfo.exhibition.logo : "",
        };
        this.shareToWechat(opt);
      } else {
        this.getConfig(); // 获取微信分享配置(所有页面)
      }
    },
  },
  // beforeCreate(){
  //   const login = sessionStorage.getItem('login');
  //   if (login !== 'true') {
  //     // 如果没有登录 则重新请求
  //     localStorage.clear();
  //   }
  // },
  async created() {
    console.log("开始执行app----------");
    isPc(this);
    this.setIsWeixin(isWeixin());
    console.log("当前是否在微信环境下", isWeixin());
    this.setConfig(config);
    this.getCountry();
  },
  computed: {
    ...mapGetters({
      hasAuth: "getHasAuth",
      oidcIsAuthenticated: "oidcIsAuthenticated",
      exhibitionInfo: "getExhibitionInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setToken: "setToken",
      setConfig: "setConfig",
      setCountry: "setCountry",
      setIsWeixin: "setIsWeixin",
    }),
    ...mapActions({
      authenticateOidcSilent: "authenticateOidcSilent",
      getConfig: "wxShare/getConfig",
      wxHideAllMenu: "wxShare/wxHideAllMenu",
      shareToWechat: "wxShare/shareToWechat",
      graphqlPost: "en/graphqlPostByZXS",
    }),
    addLink(src) {
      const script = document.createElement("script");
      script.src = src;
      script.language = "JavaScript";
      document.body.appendChild(script);
    },
    async getCountry() {
      let query = `
          query($order:String){
            countryQuery{
              get2(order: $order){
                name
                nameEn
                id
                code
                param
                shortNameEn
              }
            }
          }`;
      let opt = {
        query: query,
        variables: {
          order: "nameEn",
        },
      };
      let res = await this.graphqlPost(opt);
      console.log(res, "res国家地区");
      if (res.data.countryQuery.get2) {
        // 国家地区
        res.data.countryQuery.get2.map((c) => {
          c.shortNameEn = c.shortNameEn.toLowerCase();
        });
        this.setCountry(res.data.countryQuery.get2);
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: block;
  background: #fff;
  width: 100%;
}
</style>
